var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBadgeFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96763 0.75C3.51647 0.75 0.71875 3.54772 0.71875 6.99888C0.71875 10.45 3.51647 13.2478 6.96763 13.2478C10.4188 13.2478 13.2165 10.45 13.2165 6.99888C13.2165 3.54772 10.4188 0.75 6.96763 0.75ZM6.21765 9.5C6.21765 9.08579 6.55344 8.75 6.96765 8.75H6.97223C7.38645 8.75 7.72223 9.08579 7.72223 9.5V9.50458C7.72223 9.9188 7.38645 10.2546 6.97223 10.2546H6.96765C6.55344 10.2546 6.21765 9.9188 6.21765 9.50458V9.5ZM7.71765 4.4502C7.71765 4.03598 7.38187 3.7002 6.96765 3.7002C6.55344 3.7002 6.21765 4.03598 6.21765 4.4502V7.2502C6.21765 7.66441 6.55344 8.0002 6.96765 8.0002C7.38187 8.0002 7.71765 7.66441 7.71765 7.2502V4.4502Z",
    fill: "#B4371B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadgeFail);
export default __webpack_public_path__ + "static/media/iconBadgeFail.d45bfedc83ba32f5d04226882a1f3f9e.svg";
export { ForwardRef as ReactComponent };